import React, { useState, useEffect } from "react";
import { getCookie, deleteCookie } from "../utility/cookieProvider";
import { INVALID_SESSION_KEY } from "../constants/app-constant";
import ConceptLogo from "../assets/images/conceptbiu-logo.png";
import forgotPasswordLeftImage from "../assets/images/forgot-password-left-image.svg";
import journolistLogo from "../assets/images/journolist-logo.png";

const ForgotPassword = ({ history, location }) => {
  const [setIsInvalidSession] = useState(false);
  useEffect(() => {
    document.body.classList.add("loginPage");
    const isInvalid = getCookie(INVALID_SESSION_KEY);
    if (isInvalid) {
      setIsInvalidSession(true);
      deleteCookie(INVALID_SESSION_KEY);
    }
    return () => {
      document.body.classList.remove("loginPage");
    };
  }, []);

  return (
    <div className="loginWrap">
      <div className="loginSection forgotPassword">
        <div className="loginLeftImage">
          <img src={forgotPasswordLeftImage} alt="Signin Left Image" />
        </div>
        <div className="loginCard">
          <div className="logoWrap">
            <span>
              <img
                src={ConceptLogo}
                alt="Concept BIU"
                width="65"
                height="65"
              />
            </span>
            <span>
              <img
                src={journolistLogo}
                alt="Journolist Logo"
                width="143"
                height="36"
              />
            </span>
          </div>
          <h1 className="heading">
            Forgot <br /> Password?
          </h1>
          <p className="infoText">
            For support please contact your client servicing executive or write
            to
          </p>
          <a href="mailto:support@cocnceptbiu.com" className="contactLink">
            support@conceptbiu.com
          </a>
          <div className="goBackSignin">
            Go back to <a href="/">Sign in</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
